
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/acheter/guide/actualites-tendances-conseils",
      function () {
        return require("private-next-pages/acheter/guide/actualites-tendances-conseils/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/acheter/guide/actualites-tendances-conseils"])
      });
    }
  